module.exports = __webpack_public_path__ + "static/media/mic-on.1dff8ce9.svg";